<template>
    <div class="main">
        <div class="head_box">
            <div class="head_left">
                <img class="logo_img" src="@/assets/image/auth/logo_white.png" alt="" />
                <span class="head_title">项目系统-员工档案-{{ resume_name }}</span>
            </div>
        </div>
        <div class="button_options">
            <Button type="primary" size="small" style="font-size:12px" @click="click_add">
                <Icon type="md-add" />添加新文件
            </Button>
        </div>
        

        <div class="file_box">

            <div class="menu_list">
                <div v-for="(menu_item, menu_i) in file_list" :key="menu_i"
                    :class="menu_index == menu_i ? 'menu_list_inner2' : 'menu_list_inner'" @click="menu_index = menu_i">
                    <div class="purpose_name_div">
                        <span class="purpose_name_span">{{ menu_item.purpose_name }}</span>

                        <Tag checkable>{{ menu_item.child_list.length }}</Tag>

                    </div>
                </div>
            </div>
            <div v-if="file_list">
                <div v-if="file_list[menu_index]">
                    <div v-if="file_list[menu_index].child_list" class="file_card_div">

                        <div v-for="(item, i) in file_list[menu_index]['child_list']" :key="i" class="file_item">
                            <div class="purpose_name">
                                {{ item.purpose_name }}
                            </div>
                            <div class="file_name">
                                <div class="flle_name1">文件名称：</div>
                                {{ item.name?item.name:'-' }}
                            </div>
                            <div class="file_name">
                                <div class="flle_name1">文件后缀：</div>
                                {{ item.file_type }}
                            </div>
                            <div class="file_name">
                                <div class="flle_name1">创建时间：</div>
                                {{ item.create_time }}
                            </div>

                            <div class="download_span">
                                <span @click="click_file(item)" style="margin-right:10px">
                                    <Icon type="md-eye" />
                                    查看
                                </span>
                                <span @click="click_down(item)">
                                    <Icon type="md-cloud-download" />
                                    下载
                                </span>

                            </div>


                        </div>
                    </div>
                </div>


            </div>
        </div>

        <Modal v-model="add_show" title="添加新文件" :footer-hide="true" width="400">
            <div class="add_item">
                <div class="add_field">文件用途：</div>
                <Select clearable filterable v-model="purpose_id" style="width:200px">
                    <Option v-for="item in purposee_list" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
            </div>
            <!-- <div class="add_item">
                <div class="add_field">文件类型：</div>
                <Select clearable v-model="file_type" style="width:200px">
                    <Option v-for="item in file_type_list" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
            </div> -->
            <div class="add_item">
                <div class="add_field">文件：</div>
                <Upload ref="upload_file" :action="upload_url + '&suffix=' + file_type" :on-success="upload_success" max-size="81920">
                    <Button style="font-size:12px;width:200px" icon="ios-cloud-upload-outline">上传文件</Button>
                </Upload>
            </div>
            <!-- <div class="add_item">
                <div class="add_field">文件名称：</div>
                <Input v-model="name" placeholder="请输入文件名称" style="width: 200px" />
            </div> -->


            <div class="button_div">
                <Button style="font-size:12px" :loading="add_file_loading" type="primary"
                    @click="click_upload_ok">确认上传</Button>
            </div>

        </Modal>
    </div>
</template>

<script>
import my_menu from '@/component/menu/menu.vue'
import { http, open_new_page } from "@/utils/http.js";

export default {
    components: {
        my_menu
    },
    data() {
        return {
            windowWidth: document.documentElement.clientWidth,  //实时屏幕宽度
            windowHeight: document.documentElement.clientHeight,   //实时屏幕高度

            //系统列表
            menu_index: 0,
            resume_id: '',
            project_id: '',
            table_loading: false,
            add_show: false,

            file_type_list: [
                {
                    value: 'png',
                    label: '图片'
                },
                {
                    value: 'pdf',
                    label: 'PDF文件'
                },
                {
                    value: 'doc',
                    label: 'Doc文档'
                },
                {
                    value: 'xls',
                    label: 'Excel表格'
                }

            ],
            file_type: 'png',
            file_url: '',
            file_object_name:"",

            upload_url: process.env.VUE_APP_HOST + "/roster_manage/staff_file/upload_staff_file?token=" + this.$cookies.get('dx_token'),
            purposee_list: [],
            purpose_id: "",
            add_file_loading: false,
            file_list: [],
            name: '',
            resume_name: ''
        }
    },

    mounted() {
        this.window_change()
        this.resume_id = this.$route.query.resume_id
        this.project_id = this.$route.query.project_id
        this.get_file_list()
        this.get_purposee_list()
    },

    methods: {

        click_down(item) {
            open_new_page(item.url)
        },

        click_file(item) {
            if (item.file_type == 'pdf') {
                open_new_page(item.url)
                return
            }
            if (item.file_type == 'png') {
                this.$ImagePreview.show({
                    previewList: [item.url]
                });
                return
            }

            this.$Message.error('请点击下载，后查看')


        },

        //获取用途列表
        get_purposee_list() {
            var that = this
            var obj = {
            }
            http("post", process.env.VUE_APP_HOST + "/roster_manage/staff_file/purposee_list", obj, true).then(
                (res) => {
                    if (res.code == 0) {
                        this.purposee_list = res.data.purposee_list
                        this.purpose_id = res.data.purposee_list[0]['value']
                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                }
            ).catch((res) => {

                console.log(res, '请求出错')
            })
        },


        click_upload_ok() {
            var that = this
            var obj = {
                resume_id: this.resume_id,
                project_id: this.project_id,
                purpose_id: this.purpose_id,
                object_name: this.file_object_name,
                file_type: this.file_type,

            }
            this.add_file_loading = true
            http("post", process.env.VUE_APP_HOST + "/roster_manage/staff_file/add_file", obj, true).then(
                (res) => {
                    if (res.code == 0) {
                        that.$Message.success({
                            content: res.msg,
                            duration: 3,
                        });
                        that.get_file_list()
                        that.add_show = false


                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                    that.add_file_loading = false
                }
            ).catch((res) => {
                that.add_file_loading = false

                console.log(res, '请求出错')
            })
        },

        upload_success(e) {
            console.log(e)
            if(e.code==0){
                this.file_object_name = e.data.object_name
                this.file_type = e.data.suffix
            }else{
                this.$Message.error(e.msg)
                this.$refs.upload_file.clearFiles()
            }
            
        },

        click_add() {
            this.add_show = true
        },



        get_file_list() {
            var that = this
            var obj = {
                resume_id: this.resume_id
            }
            this.table_loading = true
            http("post", process.env.VUE_APP_HOST + "/roster_manage/staff_file/file_list", obj, true).then(
                (res) => {
                    if (res.code == 0) {
                        that.$Message.success({
                            content: res.msg,
                            duration: 3,
                        });
                        that.file_list = res.data.file_list
                        that.resume_name = res.data.name

                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                    that.table_loading = false
                }
            ).catch((res) => {
                that.table_loading = false

                console.log(res, '请求出错')
            })
        },

        window_change() {
            var that = this;
            // <!--把window.onresize事件挂在到mounted函数上-->
            window.onresize = () => {
                return (() => {
                    window.fullHeight = document.documentElement.clientHeight;
                    window.fullWidth = document.documentElement.clientWidth;
                    that.windowHeight = window.fullHeight;  // 高
                    that.windowWidth = window.fullWidth; // 宽
                })()
            };
        }
    }
}
</script>

<style scoped>
.purpose_name_span{
    font-size:13px;
    padding-right:10px;
}

.purpose_name_div {
    display: flex;
    align-items: center;
    justify-content: space-between
}

.file_card_div {
    display: flex;
    flex-wrap: wrap;
}

.menu_list_inner:hover {
    background: #f0f4f9;
}

.menu_list_inner {
    padding: 5px 10px;
    cursor: pointer;
    margin-bottom:5px;
}

.menu_list_inner2 {
    padding: 5px 10px;
    background: #0466dd;
    color: #fff;
    cursor: pointer;
    margin-bottom:5px;

}

.menu_list {
    margin-left: 20px;
    width: 180px;
    padding: 10px;
    background: #fff;
    border-radius: 5px;
    flex-shrink: 0;
    margin-right: 20px;

}

.menu_card {
    background: #fff;
    padding: 10px;
}

.flle_name1 {
    width: 80px;
    flex-shrink: 0;
}

.download_span {
    margin-top: 5px;
    color: #0466dd;
    font-size: 12px;
    display: flex;
    justify-content: flex-end;
}

.file_name {
    font-size: 13px;
    color: #555;
    cursor: pointer;
    display: flex;
    align-items: center;
}

.purpose_name {
    background-color: #56b968;
    color: #fff;
    font-size: 12px;
    position: absolute;
    left: 0;
    top: 0;
    padding: 3px 15px;
    border-radius: 5px 0px 5px 0;
}

.button_options {
    padding: 10px;
    display: flex;
    justify-content: flex-end;
}

.file_box {
    width: 100%;
    height: calc(100% - 100px);
    overflow: auto;
    display: flex;


}

.file_item {
    width: 250px;
    position: relative;
    padding: 5px 10px;
    border-radius: 5px;
    margin: 10px 10px 10px 0;
    background-color: #fff;
    padding-top: 30px;
    cursor: pointer;
}

.button_div {
    display: flex;
    justify-content: flex-end;
}

.add_field {
    width: 80px;
    flex-shrink: 0;
}

.add_item {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
}

.logo_img {
    width: 30px;
    height: 30px;
    margin-right: 10px;

}

.head_title {
    cursor: pointer;
    letter-spacing: 3px;
    font-size: 14px;
    font-weight: 400;
    color: rgb(255, 255, 255);
}

.head_left {
    display: flex;
    align-items: center;
}

.head_box {
    background: #0466dd;
    height: 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 0 0 40px;
}

.main {
    background: #f5f7f9;
    min-height: 100vh;
}
</style>